"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var action_context_1 = require("../action-context/action-context");
var dispatch_1 = require("./dispatch");
var add_trigger_1 = require("./add-trigger");
var constrain_focus_1 = require("../constrain-focus/constrain-focus");
var mouseover_focusable_1 = require("./mouseover-focusable");
function setFocusedContext() {
    var focused = document.activeElement;
    if (!focused)
        return;
    var focusedElement;
    if (!(focused instanceof HTMLElement) && focused.parentElement) {
        focusedElement = focused.parentElement;
    }
    else {
        focusedElement = focused;
    }
    if (!focusedElement)
        return;
    action_context_1.ActionContextService.setContext(focusedElement);
}
function keydown(e) {
    setFocusedContext();
    action_context_1.ActionContextService.handleKeypress(e);
}
function observe(mutations) {
    mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
            if (!(n instanceof HTMLElement))
                return;
            dispatch_1.dispatch(n);
        });
        if (m.type == "attributes" && m.target instanceof HTMLElement) {
            if (m.target.dataset.phocusAction) {
                add_trigger_1.addTrigger(m.target);
            }
            else {
                add_trigger_1.removeTrigger(m.target);
            }
        }
    });
}
var observer;
function startPhocus(elt) {
    dispatch_1.dispatch(elt);
    document.addEventListener("keydown", keydown);
    document.addEventListener("mousemove", mouseover_focusable_1.setMoving);
    observer = new MutationObserver(observe);
    observer.observe(elt, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["data-phocus-action", "data-phocus-on-mouseover"]
    });
    constrain_focus_1.ConstrainFocusService.start();
}
exports.startPhocus = startPhocus;
function stopPhocus(elt) {
    dispatch_1.undispatch(elt);
    document.removeEventListener("keydown", keydown);
    document.removeEventListener("mousemove", mouseover_focusable_1.setMoving);
    observer.disconnect();
    constrain_focus_1.ConstrainFocusService.stop();
}
exports.stopPhocus = stopPhocus;
//# sourceMappingURL=start-phocus.js.map